import { Box, Container } from "@mui/material";
import { PrimaryButton } from "../../components/ui/Button";
import { useNavigate } from "react-router-dom";

const SessionTimeout = () => {
  const navigate = useNavigate();
  return (
    <Container component="main" className="content-not-found">
      <Box className="main-section">
        <Box className="heading">Session Time Out</Box>
        <Box className="sub-heading">
          Session has got timed out. Please login again.
        </Box>
        <Box className="action-section">
          <PrimaryButton
            sx={{
              minWidth: "540px",
              // Add media query for smaller screens
              "@media (max-width: 600px)": {
                minWidth: "calc(100% - 32px)", // Adjust width for mobile
              },
            }}
            onClick={() => navigate("/login")}
          >
            Login
          </PrimaryButton>
        </Box>
      </Box>
    </Container>
  );
};

export default SessionTimeout;
